import { INotification } from "infrastructure/notification";

export interface IEnterprise {
  enterpriseId: string;
  name: string;
}

export interface IEnterprisesState {
  [x: string]: IEnterprisesList;
}

export interface IEnterprisesList {
  items: IEnterprise[];
  isLoading: boolean;
  notification?: INotification;
}

export const getInitialEnterprisesState = (): IEnterprisesState => {
  return {};
};
